import { render, staticRenderFns } from "./AddProductsByCategoryModal.vue?vue&type=template&id=7ed5b5fd"
import script from "./AddProductsByCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddProductsByCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports